<div class="toolkit">
    <div class="row">
        <div class="col-lg-12 col-xs-12 col-md-12 col-sm-12" id="page-content">
            <H1 class="title-container-service">Contacter le service client GS1</H1>
        </div>
    </div>
    <div class="container">
        <div class="row" *ngIf="loading">
            <img src="/assets/images/loading/Gear.svg" class="chargement" />
        </div>
        <form (ngSubmit)="onSubmit(contactForm,$event)" [hidden]="errors||loading" #contactForm="ngForm">
            <div class="col-md-6 noPaddingLeft">
                <div class="row">
                    <p id="Formulaire-de-contact">{{ 'ContactServiceClient.PAR_FORMULAIRE' | translate }}</p>
                </div>
                <div class="row">
                    <br />
                    <p id="Veuillez-nous-expliquer">{{ 'ContactServiceClient.MESSAGE_FORMULAIRE_CONTACT' | translate }}</p>
                    <br />
                </div>
                <div class="row col-md-11 noPaddingLeft">

                    <label id="Name-of-field" for="sujet">{{ 'ContactServiceClient.SUJET:' | translate }}*</label>
                    <input type="text" [(ngModel)]="form.sujet" class="form-control" id="sujet" name="sujet" maxlength="200" required #sujet="ngModel">
                    <div><small>{{'ContactServiceClient.SUJET_TAILLE_MAX' | translate}}</small></div>
                    <div *ngIf="showErrorMessage(contactForm,'sujet')" class="alert alert-danger">
                        {{ 'ContactServiceClient.SUJET_OBLIGATOIRE' | translate }}

                    </div>
                </div>
                <br />
                <div class="row">
                    <label id="Name-of-field" for="fichier">{{ 'ContactServiceClient.PIECE_JOINTE:' | translate }}</label>
                    <br />
                    <span *ngIf="form.file">{{form.file.name}}</span>
                    <button type="button" id="exporter" class="btn-tertiary btn-with-img width-button" (click)="file.click()" style="width:220px;">
                        <div class="div-img-logo border-img-download"><img src="assets/images/icons/hub/ico-action-download-orange.svg" class="img-logo" /></div><div class="div-btn-text">Ajouter votre fichier</div>
                    </button>
                    
                    <br />
                    <input [ngModel]="form.message" name="fichier" type="file" class="hidden" id="fichier" #file (change)="onChange(file.files[0])"  />
                    <div><small>{{'ContactServiceClient.PJ_TAILLE_MAX' | translate}}</small></div>
                    <div *ngIf="sizeMax" class="alert alert-danger">
                        {{ 'ContactServiceClient.PJ_TAILLE_MAX' | translate }}
                    </div>
                    <div *ngIf="!extenstionResult" class="alert alert-danger" style="font-size: 14px">
                        {{ 'ContactServiceClient.PJ_FORMAT_KO' | translate }}
                    </div>
                </div>

                <br />
                <div class="row">
                    <label id="Name-of-field" for="message">{{ 'ContactServiceClient.MESSAGE:' | translate }}*</label>
                    <textarea [(ngModel)]="form.message" class="form-control" id="message" name="message" style="width:280px; height:166px" required #message="ngModel">
                        </textarea>
                    <!--<div><small>{{'ContactServiceClient.MESSAGE_TAILLE_MAX' | translate}}</small></div>-->
                    <div *ngIf="showErrorMessage(contactForm,'message')" class="alert alert-danger">
                        {{ 'ContactServiceClient.MESSAGE_OBLIGATOIRE' | translate }}
                    </div>
                </div>
                <br />
                <div class="row">
                    <button type="submit" class="btn btn-primary" [disabled]="!extenstionResult" >{{ 'ContactServiceClient.ENVOYER' | translate }}</button>
                </div>
                <br />
                <div class="row">
                    <div *ngIf="retourOK && timeOut" class="alert alert-success" role="alert">{{ 'ContactServiceClient.RETOUR_OK' | translate }}</div>
                    <div *ngIf="retourKO && timeOut" class="alert alert-danger" role="alert">{{ 'ContactServiceClient.PROBLEME_SURVENU' | translate }}</div>
                </div>

            </div>
            <div class="col-md-6 noPaddingLeft">
                <div class="row">
                    <p id="Formulaire-de-contact">{{'ContactServiceClient.PAR_TELEPHONE' | translate}}</p>
                </div>
                <div class="row">
                    <br />
                    <p id="Veuillez-nous-expliquer">{{ 'ContactServiceClient.MESSAGE_TELEPHONE' | translate }}</p> 
                    <br />
                </div>
            

            </div>
        </form>
        
    </div>
        
</div>